import { render, staticRenderFns } from "./SheetVehicleFeatureHeader.vue?vue&type=template&id=37ea6f1d&scoped=true&"
import script from "./SheetVehicleFeatureHeader.vue?vue&type=script&lang=js&"
export * from "./SheetVehicleFeatureHeader.vue?vue&type=script&lang=js&"
import style0 from "./SheetVehicleFeatureHeader.vue?vue&type=style&index=0&id=37ea6f1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ea6f1d",
  null
  
)

export default component.exports